module.exports = __webpack_public_path__ + "assets/img/returnBtn-b181fd16.png";